import type { ReactNode } from 'react';

export const symbol_responsive_layout: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-180v-385q0-24.75 17.63-42.38Q155.25-625 180-625h155v-155q0-24.75 17.63-42.38Q370.25-840 395-840h385q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180q-24.75 0-42.37-17.63Q120-155.25 120-180Zm505 0h155v-600H395v155h170q24.75 0 42.38 17.62Q625-589.75 625-565v385Zm-230 0h170v-385H395v385Zm-215 0h155v-385H180v385Z"
		/>
	</svg>
);
